import { selectIsUserAgent } from '../../packages/Filters/shared/selectors';
import { IAppState } from '../common/state';

export const selectIsProfessionalSearchPromoBannerVisible = (state: IAppState) => {
  const isAgent = selectIsUserAgent(state);

  return isAgent;
};
